import { render, staticRenderFns } from "./BasicPage.vue?vue&type=template&id=b299a9ca"
import script from "./BasicPage.vue?vue&type=script&lang=js"
export * from "./BasicPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports